import { FC, useState } from 'react';
import { AlanBoswellLogo } from './AlanBoswellLogo';
import { PageSizer } from './PageSizer';
import strings from './pages.translations';
import { HeaderLink } from './HeaderLink';
import { UserMenu } from './UserMenu';
import { SearchBar } from '../file/SearchBar';
import { FiMenu } from 'react-icons/fi';
import Drawer from 'react-modern-drawer';
import { NavDrawerLink } from './NavDrawerLink';
import StatusMenu from '../file/StatusMenu';

export interface HeaderPage {
  name: string;
  url: string;
}

const headerPages: HeaderPage[] = [
  {
    name: strings.common.pages.home,
    url: '/'
  },
  {
    name: strings.common.pages.documents,
    url: '/documents/myDocuments'
  }
];

const mobileHeaderPages: HeaderPage[] = [
  ...headerPages,
  {
    name: strings.userMenu.logout,
    url: '/auth/signout'
  }
];

const SiteHeaderDesktop: FC = () => {
  return (
    <PageSizer className="hidden md:flex items-center gap-10">
      <AlanBoswellLogo />
      <div className="flex items-center gap-5 flex-1">
        {headerPages.map(page => (
          <HeaderLink page={page} key={page.url} />
        ))}
      </div>
      <div className="flex items-center gap-5">
        <StatusMenu />
        <SearchBar className="w-60" showButton={false} />
        <UserMenu />
      </div>
    </PageSizer>
  );
};

const SiteHeaderMobile: FC = () => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);

  return (
    <>
      <PageSizer className="flex md:hidden items-center justify-between gap-10">
        <button onClick={() => setDrawerOpen(!drawerOpen)}>
          <FiMenu className="w-8 h-8 text-primary-800" />
        </button>
        <AlanBoswellLogo />
        <StatusMenu />
      </PageSizer>
      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)} direction="left">
        <div className="p-5 border-b">
          <AlanBoswellLogo />
        </div>
        <div className="flex flex-col">
          {mobileHeaderPages.map(page => (
            <NavDrawerLink page={page} key={page.url} />
          ))}
        </div>
      </Drawer>
    </>
  );
};

export const SiteHeader: FC = () => {
  return (
    <div className="w-full border-b py-3 bg-primary-std">
      <SiteHeaderDesktop />
      <SiteHeaderMobile />
    </div>
  );
};
